module.exports = __webpack_public_path__ + "static/tasklist-b9c17e25fba5c17bbf283e56f2f69879.mp4";